<template>
<div :class="{'pp-album-grid':1, 'pp-album-grid--mobile-horizontal': mobileHorizontal }"
     :style="{ 'max-height': maxRows ? (($root.view == 'mobile' ? 212 : 230) * maxRows) + 'px' : '' }">
    <router-link :to="'/browse/albums/'+item.id"
                 v-for="item in realItems"
                 :key="item.id"
                 :class="{'pp-album-grid__item':1, 'pp-album-grid__item--loading': item.loading}">
        <img v-if="item.realArtwork" @load="$set(item, 'loading', false)"  :src="item.realArtwork" class="pp-album-grid__item__artwork">
        <div v-if="!item.realArtwork" class="pp-album-grid__item__artwork pp-album-grid__item__artwork--placeholder">
            Pristine Classical
        </div>

        <div class="pp-album-grid__item__title" :title="item.title">
            <div>{{ item.title }}</div>
        </div>
    </router-link>
    <loading-indicator v-if="paginating"></loading-indicator>
</div>
</template>

<script>
import Ellipsis from 'ftellipsis';
import LoadingIndicator from './LoadingIndicator.vue';
import EventBus from '../EventBus.js'
import Vue from 'vue';

export default {
    name: 'album-grid',
    components: {
        LoadingIndicator
    },
    data() {
        return {
            titleEllipsis: [],
            loadTimeout: null,
        };
    },
    props: {
        items: Array,
        maxRows: Number,
        mobileHorizontal: Boolean,
        canPaginate: Boolean,
        paginating: Boolean,
        reachedEnd: Boolean,
    },
    computed: {
        realItems() {
            var items = this.items;
            var offset = 0;
            var needArtworkItems = [];
            for (let item of items) {
                if (item.loading == undefined) {
                    this.$set(item, 'loading', true);
                    this.$set(item, 'realArtwork', null);

                    needArtworkItems.push(item);
                }
            }

            var index = 0;
            var artworkInterval = setInterval(() => {
                if (index >= needArtworkItems.length) {
                    clearInterval(artworkInterval);
                    return;
                }
                var item = needArtworkItems[index];
                this.$set(item, 'realArtwork', item.artwork);
                index++;
            }, 10);

            return items;
        }
    },
    watch: {
        items() {
            Vue.nextTick(() => {
                this.getTitleElements();
                this.onResize();

            });

            this.setLoadTimeouts();
        }
    },
    methods: {
        artworkError(album) {
            console.log('artworkError', album);
            this.$set(album, 'loading', false);
            this.$set(album, 'realArtwork', 'https://d25b8yszlw4it0.cloudfront.net/covers/missing200.png');

        },
        setLoadTimeouts() {
            if (this.loadTimeout) {
                clearTimeout(this.loadTimeout);
            }
            this.loadTimeout = setTimeout(() => {
                for (let item of this.items) {
                    this.$set(item, 'loading', false);
                }
            }, 3000);
        },
        loadMore(items) {
            for (var item of items) {
                this.items.push(item);
            }
            this.getTitleElements();
            this.onResize();
        },

        getTitleElements() {
            this.titleEllipsis = [];
            let elements = this.$el.querySelectorAll('.pp-album-grid__item__title');
            for (let element of elements) {
                element.style.lineHeight = '18px';
                var ellip = new Ellipsis(element);
                ellip.calc();
                ellip.set();

                this.titleEllipsis.push(ellip);
            }
        },

        onResize() {
            for (let ellip of this.titleEllipsis) {
                ellip.el.style.lineHeight = '18px';
                ellip.calc();
                ellip.set();
            }
        }
    },
    mounted() {
        this.getTitleElements();
        window.addEventListener('resize', () => this.onResize());

        EventBus.on('navigation.scrolling', (e) => {
            if (this.canPaginate && !this.reachedEnd && !this.paginating && e.data.fromBottom < 300) {
                this.$emit('paginate');
            }
        });

        this.setLoadTimeouts();
    }
};
</script>



// WEBPACK FOOTER //
// AlbumGrid.vue?9fba7fa4